module.exports = __webpack_public_path__ + "img/arthanindo.2a573e1b.png";